import React from 'react';

import { Modal } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalContent } from './ModalContent';
import { ModalHeader } from './ModalHeader';
import { ModalHeaderContent } from './ModalHeaderContent';
import { ModalSubtitle } from './ModalSubtitle';
import { ModalTitle } from './ModalTitle';

const DebugDumpModal = ({ title, data = null, children, onClose }) => {
  let content = children;

  // stringify data as the content, otherwise use the children
  if (data) {
    content = (
      <div className="overflow-auto rounded-md bg-gray-100 p-2 font-mono text-3xs whitespace-pre-wrap">
        {JSON.stringify(data || {}, null, 2)}
      </div>
    );
  }

  return (
    <Modal onClose={onClose}>
      <ModalBody className="flex h-full flex-col">
        <ModalHeaderContent>
          <ModalHeader>
            <ModalSubtitle>Debug Dump</ModalSubtitle>
            <ModalTitle>{title}</ModalTitle>
          </ModalHeader>
        </ModalHeaderContent>

        <ModalContent>{content}</ModalContent>
      </ModalBody>
    </Modal>
  );
};

export default DebugDumpModal;
